module.exports = __webpack_public_path__ + "static/img/40018 (5).0be9cac.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40018 (5).webp
// module id = JBtP
// module chunks = 14